import { Roles } from "../constants";
import { APP_ROUTES } from "../helpers/routeHelpers";
import { ACCESS } from "../helpers/access";
import AnalyticsIconDark from "../assets/images/app/common/analytics-icon-dark.svg";

let { Admin } = Roles;

// Every entry here was a tab on one hub page in the admin console — see
// routeHelpers.APP_ROUTES for the "why top-level routes now" note. Same
// icon reused across all of them on purpose: they aren't different kinds of
// screen the way BLS Feedback and Content Library were in that console,
// they're one dashboard's sections, and a single consistent glyph says so
// at a glance rather than eight arbitrary ones implying eight products.
const SIDEBAR_CONFIG = [
  {
    title: "Overview",
    url: APP_ROUTES.OVERVIEW,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Engagement",
    url: APP_ROUTES.ENGAGEMENT,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Wellbeing",
    url: APP_ROUTES.WELLBEING,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Resets & Content",
    url: APP_ROUTES.RESETS_CONTENT,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    // Was "Implementation" — renamed because this is the tab that shows
    // school-by-school comparison and drills into one school's own playback/
    // activity detail. "Implementation" said nothing about that; "School
    // Insights" does.
    title: "School Insights",
    url: APP_ROUTES.IMPLEMENTATION,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Payments & Licensing",
    url: APP_ROUTES.PAYMENTS_LICENSING,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    // Its own glyph, unlike the analytics sections above: this is a different
    // kind of screen (live conversations), behind a different grant.
    title: "Inbox",
    url: APP_ROUTES.INBOX,
    // Both channels now (WhatsApp and the website chat), so a generic chat glyph.
    icon: "mdi mdi-forum-outline",
    menuImg: null,
    nestedMenu: null,
    permissions: [Admin],
    access: ACCESS.INBOX,
  },
  {
    title: "Platform Health",
    url: APP_ROUTES.PLATFORM_HEALTH,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
  {
    title: "Settings",
    url: APP_ROUTES.SETTINGS,
    icon: null,
    menuImg: AnalyticsIconDark,
    nestedMenu: null,
    permissions: [Admin],
  },
];

export default SIDEBAR_CONFIG;
